document.addEventListener('DOMContentLoaded', function() {
  const dropdowns = document.querySelectorAll('[data-custom-dropdown]');
  
  dropdowns.forEach(dropdown => {
    const header = dropdown.querySelector('[data-dropdown-header]');
    const content = dropdown.querySelector('[data-dropdown-content]');
    const selectedText = dropdown.querySelector('.dropdown-selected span');
    const options = dropdown.querySelectorAll('.dropdown-option');
    const priceDisplay = dropdown.closest('.price-container').querySelector('.price-value');
    
    header.addEventListener('click', function(e) {
      e.stopPropagation();
      
      dropdowns.forEach(otherDropdown => {
        if (otherDropdown !== dropdown) {
          otherDropdown.classList.remove('expanded');
        }
      });
      
      dropdown.classList.toggle('expanded');
    });
    
    options.forEach(option => {
      option.addEventListener('click', function(e) {
        e.stopPropagation();
        
        const value = this.getAttribute('data-value');
        const price = this.getAttribute('data-price');
        const text = this.textContent;
        
        selectedText.textContent = text;
        
        options.forEach(opt => opt.classList.remove('selected'));
        this.classList.add('selected');
        
        if (priceDisplay) {
          const fromText = priceDisplay.querySelector('.from-text');
          if (fromText) {
            priceDisplay.innerHTML = `<span class="from-text">Price - </span> ${price}`;
          } else {
            priceDisplay.textContent = price;
          }
        }
        
        dropdown.classList.remove('expanded');
        
        const event = new CustomEvent('priceSelected', {
          detail: { value, price, text }
        });
        dropdown.dispatchEvent(event);
      });
    });
    
    document.addEventListener('click', function() {
      dropdowns.forEach(dropdown => {
        dropdown.classList.remove('expanded');
      });
    });
    
    content.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  });
});